// src/pages/technique/TaskToolbar.jsx
import React, { useState, useEffect, useCallback   } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X, CalendarDays, ChevronDown, LogOut, Filter, AlertCircle, Clock, Users, Building, Package , BarChart3, FileText, Home  , Settings } from 'lucide-react';
import axios from 'axios';
import gecimo_logo from '../../image/gecimo_logo.jpg'; // Assurez-vous que le chemin est correct
import api from '../../api';

const TaskToolbar = ({
  onShowForm,
  onSearch,
  onDateStartChange,
  onDateEndChange,
  onPriorityChange = () => {},
  onTypeChange = () => {},
  onModuleChange = () => {},
  onOrganisationChange = () => {},
  onDeadlineTechChange = () => {},
  onDeadlineClientChange = () => {},
  onResetFilters = () => {},
  onLogout,
  currentValues = {}
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [modules, setModules] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [showNavMenu, setShowNavMenu] = useState(false);
  const [localSearch, setLocalSearch] = useState(currentValues.searchTerm || '');
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    setShowNavMenu(false); // Ferme le menu après navigation
  };

  useEffect(() => {
    setLocalSearch(currentValues.searchTerm || '');
  }, [currentValues.searchTerm]);

  // Gestion optimisée du changement
  const handleSearchChange = useCallback((e) => {
    const value = e.target.value;
    setLocalSearch(value);
    onSearch(value); // Envoi immédiat mais parent peut debouncer
  }, [onSearch]);

  const clearSearch = useCallback(() => {
    setLocalSearch('');
    onSearch('');
  }, [onSearch]);

  // ✅ Chargement des modules et organisations pour les filtres
  useEffect(() => {
    // Charger les modules
    api.get('/modules')
      .then(res => {
        console.log('Modules chargés:', res.data);
        setModules(res.data || []);
      })
      .catch(err => console.error('Erreur chargement modules:', err));

    // Charger les organisations
    api.get('/organisations')
      .then(res => {
        setOrganisations(res.data.organisations || []);
      })
      .catch(err => console.error('Erreur chargement organisations:', err));
  }, []);

  const priorityOptions = [
    { value: '', label: 'Toutes les priorités' },
    { value: '1', label: 'Basse' },
    { value: '2', label: 'Moyenne' },
    { value: '3', label: 'Haute' },
  ];

  const typeOptions = [
    { value: '', label: 'Tous les types' },
    { value: 'bug', label: 'Bug' },
    { value: 'demande', label: 'Demande' }
  ];

    const navigationItems = [
    {
      name: 'Home',
      icon: Home ,
      path: '/ChefProjet/home',
      description: 'Vue d\'ensemble des projets'
    },
    {
      name: 'Tableau de bord',
      icon: BarChart3,
      path: '/ChefProjet/dashboard',
      description: 'Vue d\'ensemble des projets'
    },
    {
      name: 'Gestion des demandes',
      icon: FileText,
      path: '/ChefProjet/demande',
      description: 'Gérer les demandes clients'
    },
  ];

  // ✅ Fonction pour réinitialiser tous les filtres
  const handleResetAllFilters = () => {
    // Réinitialiser les champs du formulaire
    const form = document.querySelector('.filters-form');
    if (form) {
      const inputs = form.querySelectorAll('input, select');
      inputs.forEach(input => {
        if (input.type === 'date' || input.type === 'text') {
          input.value = '';
        } else if (input.tagName === 'SELECT') {
          input.selectedIndex = 0;
        }
      });
    }
    
    // Réinitialiser la barre de recherche
    const searchInput = document.querySelector('input[placeholder*="Rechercher"]');
    if (searchInput) {
      searchInput.value = '';
    }
    
    // Appeler la fonction de réinitialisation du parent
    onResetFilters();
  };

  return (
    <div className="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-lg">
      {/* Main Toolbar */}
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          {/* Logo & Title */}
          <div className="flex items-center space-x-3 min-w-[120px]">
            <div className="relative">
              <img 
                src={gecimo_logo}
                alt="Logo" 
                className="h-8 w-auto object-contain rounded-md shadow-sm" 
              />
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-[#875A7B] rounded-full animate-pulse"></div>
            </div>
            <div className="hidden md:block">
              <h1 className="text-lg font-bold text-gray-800">Tickets</h1>
              <p className="text-xs text-gray-500">Gestion des tâches</p>
            </div>
          </div>

          {/* Search Bar */}
          {/* <div className="flex-1 max-w-2xl min-w-[200px] mx-4">
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-gray-400 group-focus-within:text-[#875A7B] transition-colors" />
              </div>
              <input
                type="text"
                placeholder="Rechercher par titre, description, module..."
                defaultValue={currentValues.searchTerm || ''}
                onChange={e => onSearch(e.target.value)}
                className="block w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl text-sm bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-[#875A7B]/20 focus:border-[#875A7B] focus:bg-white transition-all duration-300 hover:border-gray-300"
              />
            </div>
          </div> */}
          
 <div className="flex-1 max-w-2xl min-w-[200px] mx-4">
      <div className="relative group">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-4 w-4 text-gray-400 group-focus-within:text-[#875A7B]" />
        </div>
        <input
          type="text"
          placeholder="Rechercher par titre, description, module..."
          value={localSearch}
          onChange={handleSearchChange}
          className="block w-full pl-10 pr-8 py-2 border border-gray-200 rounded-xl text-sm bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-[#875A7B]/20 focus:border-[#875A7B] transition-all"
        />
        {localSearch && (
          <button
            onClick={clearSearch}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
          >
            <X className="h-4 w-4 text-gray-400 hover:text-gray-600" />
          </button>
        )}
      </div>
    </div>

          <div className="flex items-center gap-3 relative">
  {/* Menu Navigation Dropdown */}
  <div className="relative">
    <button
      onClick={() => setShowNavMenu(!showNavMenu)}
      className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium bg-indigo-50 text-indigo-700 hover:bg-indigo-100 transition-all duration-300"
      title="Navigation"
    >
      <Settings className="h-4 w-4" />
      <span className="hidden sm:inline">Pages</span>
      <ChevronDown className={`h-3 w-3 transition-transform duration-200 ${showNavMenu ? 'rotate-180' : ''}`} />
    </button>

    {showNavMenu && (
      <div className="absolute right-0 mt-2 w-72 bg-white rounded-xl shadow-2xl border border-gray-200 py-2 z-30">
        <div className="px-4 py-2 border-b border-gray-100">
          <p className="text-sm font-semibold text-gray-800">Navigation</p>
          <p className="text-xs text-gray-500">Accéder aux différents modules</p>
        </div>
        {navigationItems.map((item) => (
          <button
            key={item.path}
            onClick={() => handleNavigation(item.path)}
            className="w-full flex items-start gap-3 px-4 py-3 text-left hover:bg-gray-50 transition-colors"
          >
            <item.icon className="h-5 w-5 text-[#875A7B] mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-gray-800">{item.name}</p>
              <p className="text-xs text-gray-500">{item.description}</p>
            </div>
          </button>
        ))}
      </div>
    )}
  </div>
</div>
          

          {/* Actions */}
          <div className="flex items-center gap-3">
            
            {/* Filter Toggle */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 ${
                showFilters 
                  ? 'bg-[#875A7B] text-white shadow-lg shadow-[#875A7B]/25' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
              title="Filtres avancés"
            >
              <Filter className="h-4 w-4" />
              <span className="hidden sm:inline">Filtres</span>
              <ChevronDown className={`h-3 w-3 transition-transform duration-200 ${showFilters ? 'rotate-180' : ''}`} />
            </button>



            {/* Logout Button */}
            <button
              onClick={onLogout}
              className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-700 hover:bg-red-50 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-300/20 transition-all duration-300"
              title="Déconnexion"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Déconnexion</span>
            </button>
          </div>
        </div>
      </div>

      {/* Advanced Filters Panel */}
      {showFilters && (
        <div className="border-t border-gray-200 bg-gradient-to-r from-gray-50 to-white px-4 py-4 animate-in slide-in-from-top-2 duration-200">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 filters-form">
            {/* Date Range Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <CalendarDays className="h-4 w-4 text-[#875A7B]" />
                Période
              </label>
              <div className="flex items-center space-x-2">
                <input
                  type="date"
                  defaultValue={currentValues.dateStart || ''}
                  onChange={e => onDateStartChange(e.target.value)}
                  className="text-xs border border-gray-200 rounded-lg px-3 py-2 w-full bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all"
                  title="Date de début"
                />
                <span className="text-xs text-gray-400">→</span>
                <input
                  type="date"
                  defaultValue={currentValues.dateEnd || ''}
                  onChange={e => onDateEndChange(e.target.value)}
                  className="text-xs border border-gray-200 rounded-lg px-3 py-2 w-full bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all"
                  title="Date de fin"
                />
              </div>
            </div>

            {/* Priority Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <AlertCircle className="h-4 w-4 text-[#875A7B]" />
                Priorité
              </label>
              <div className="relative">
                <select
                  defaultValue={currentValues.priorityFilter || ''}
                  onChange={e => onPriorityChange(e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all appearance-none cursor-pointer"
                >
                  {priorityOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            </div>

            {/* Type Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Package className="h-4 w-4 text-[#875A7B]" />
                Type
              </label>
              <div className="relative">
                <select
                  defaultValue={currentValues.typeFilter || ''}
                  onChange={e => onTypeChange(e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all appearance-none cursor-pointer"
                >
                  {typeOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            </div>

            {/* Module Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Package className="h-4 w-4 text-[#875A7B]" />
                Module
              </label>
              <div className="relative">
                <select
                  defaultValue={currentValues.moduleFilter || ''}
                  onChange={e => onModuleChange(e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all appearance-none cursor-pointer"
                >
                  <option value="">Tous les modules</option>
                  {modules.map(module => (
                    <option key={module.id} value={module.id}>
                      {module.nom}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            </div>

            {/* Organisation Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Building className="h-4 w-4 text-[#875A7B]" />
                Organisation
              </label>
              <div className="relative">
                <select
                  defaultValue={currentValues.organisationFilter || ''}
                  onChange={e => onOrganisationChange(e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all appearance-none cursor-pointer"
                >
                  <option value="">Toutes les organisations</option>
                  {organisations.map(org => (
                    <option key={org.id} value={org.id}>
                      {org.nomOrganisation}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            </div>

            {/* Technical Deadline Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Clock className="h-4 w-4 text-[#875A7B]" />
                Échéance technique
              </label>
              <input
                type="date"
                defaultValue={currentValues.deadlineTechFilter || ''}
                onChange={e => onDeadlineTechChange(e.target.value)}
                className="w-full text-xs border border-gray-200 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all"
                title="Échéance technique"
              />
            </div>

            {/* Client Deadline Filter */}
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Users className="h-4 w-4 text-[#875A7B]" />
                Échéance client
              </label>
              <input
                type="date"
                defaultValue={currentValues.deadlineClientFilter || ''}
                onChange={e => onDeadlineClientChange(e.target.value)}
                className="w-full text-xs border border-gray-200 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-[#875A7B]/20 focus:outline-none focus:border-[#875A7B] transition-all"
                title="Échéance client"
              />
            </div>
          </div>

          {/* Filter Actions */}
          <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-200">
            <div className="text-xs text-gray-500">
              Utilisez les filtres pour affiner votre recherche
            </div>
            <button
              onClick={handleResetAllFilters}
              className="text-xs text-[#875A7B] hover:text-[#9d6b8f] font-medium transition-colors hover:underline"
            >
              Réinitialiser tous les filtres
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskToolbar;